import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { renderAccent } from "@/components/RichText";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { useSite, wa } from "@/context/ContentContext";

export default function CTABanner() {
  const D = useSite();
  const c = D.cta;
  return (
    <section className="px-6 pb-24 md:px-12 md:pb-32">
      <Reveal className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-b from-charcoal-900 to-charcoal-950 px-8 py-20 text-center md:py-28">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-32 left-1/2 h-72 w-[36rem] -translate-x-1/2 rounded-full bg-gold/15 blur-[110px]"
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -bottom-40 -right-24 h-80 w-80 rounded-full bg-rose-400/10 blur-[100px]"
          />
          <p className="relative font-accent text-xs uppercase tracking-[0.35em] text-gold-light">
            {c.overline}
          </p>
          <h2 className="relative mx-auto mt-6 max-w-2xl font-serif text-4xl leading-[1.08] tracking-tight text-white sm:text-5xl">
            {renderAccent(c.title, "italic text-gold-light")}
          </h2>
          <p className="relative mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/60">
            {c.text}
          </p>
          <div className="relative mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              data-testid="cta-banner-whatsapp"
              href={wa(D.site, "Merhaba, kayıt ve kontenjan hakkında bilgi almak istiyorum.")}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-8 py-4 text-sm font-semibold text-white transition-all duration-500 ease-premium hover:-translate-y-0.5 hover:shadow-lift"
            >
              <WhatsAppIcon className="h-4 w-4" />
              {c.primaryLabel}
            </a>
            <Link
              data-testid="cta-banner-contact"
              to="/iletisim"
              className="group inline-flex items-center gap-2 rounded-full border border-white/25 px-8 py-4 text-sm font-semibold text-white transition-all duration-500 ease-premium hover:border-white/60 hover:bg-white/5"
            >
              {c.secondaryLabel}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
